import { JSX, PropsWithChildren, useState } from "react";
import Transaction from "../models/Transaction";
import "./Widget.css";

const Widget = (props: PropsWithChildren<{title: string, flex?: number, minWidth?: string | number, maxWidth?: string | number, canCollapse?: boolean, startCollapse?: boolean, height?: number | string}>) => {
    const [open, setOpen] = useState(props.startCollapse);
    return (
        <div className="widget" style={{flex: props.flex ? props.flex : 1, height: props.height ? props.height : "auto", minWidth: props.minWidth ? props.minWidth : "300px", maxWidth: props.maxWidth ? props.maxWidth : "100%"}}>
            <h2 className="widget-title" style={{fontSize: 20, margin: 0, display: "flex", justifyContent: "start", alignItems: "center", gap: 15}}>{props.canCollapse ? <i onClick={() => setOpen(!open)} style={{fontSize: 18}} className={open ? "fa-solid fa-chevron-up" : "fa-solid fa-chevron-down"} /> : null}{props.title}</h2>

            {open || !props.canCollapse ? <div className="widget-content" style={{marginTop: 15}}>
                {props.children}
            </div>
            : null}
        </div>
    );
}

export type DashboardWidget = (props: {transactions: Transaction[]}) => JSX.Element;
export default Widget;